export default "__VITE_ASSET__BMw2zyVs__"